/* sln-modal.js - shared modal / focus-trap. Vanilla JS. window.slnModal.open(el,{onClose}) / .close(el) */
(function () {
  if (window.slnModal) return;
  var FOCUSABLE =
    'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  var stack = [];

  function visibleFocusables(el) {
    return Array.prototype.filter.call(el.querySelectorAll(FOCUSABLE), function (n) {
      return n.offsetParent !== null;
    });
  }

  function open(el, opts) {
    if (!el) return;
    opts = opts || {};
    var rec = { el: el, prev: document.activeElement, opts: opts };
    rec.handler = function (e) {
      if (stack[stack.length - 1] !== rec) return;
      if (e.key === 'Escape') {
        e.stopPropagation();
        close(el);
        return;
      }
      if (e.key !== 'Tab') return;
      var f = visibleFocusables(el);
      if (!f.length) {
        e.preventDefault();
        return;
      }
      var first = f[0];
      var last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    };
    stack.push(rec);
    document.addEventListener('keydown', rec.handler);
    el.hidden = false;
    el.setAttribute('tabindex', '-1');
    document.documentElement.classList.add('sln-modal-open');
    var target = el.querySelector('[data-sln-autofocus]') || visibleFocusables(el)[0] || el;
    target.focus();
  }

  function close(el) {
    var idx = -1;
    for (var i = 0; i < stack.length; i++) if (stack[i].el === el) idx = i;
    if (idx === -1) return;
    var rec = stack.splice(idx, 1)[0];
    document.removeEventListener('keydown', rec.handler);
    el.hidden = true;
    if (!stack.length) document.documentElement.classList.remove('sln-modal-open');
    if (rec.prev && rec.prev.focus) rec.prev.focus();
    if (typeof rec.opts.onClose === 'function') rec.opts.onClose();
  }

  var style = document.createElement('style');
  style.textContent = 'html.sln-modal-open{overflow:hidden}';
  document.head.appendChild(style);

  window.slnModal = { open: open, close: close };
})();